"use client";

import { Tabs } from "@anu-its/ts-react-components";
import { TablePagination } from "@/app/dashboard/TablePagination";
import { SandpitSiteTable } from "@/app/dashboard/SandpitSiteTable";
import { UnclaimedSitesTable } from "@/app/dashboard/UnclaimedSitesTable";
import { MySitesTable } from "@/app/dashboard/MySitesTable";
import { TeachingSiteTable } from "@/app/dashboard/TeachingSiteTable";
import { useUserStore } from "@/app/providers/UserStore";

export default function Dashboard() {
  const { userIsSuperAdmin, userIsOrgAdmin } = useUserStore();

  return (
    <div className="container-max-width mb-5">
      <title>Dashboard | Courses and Teachers </title>
      <h1 className="sr-only">Dashboard | Courses and Teachers </h1>
      <Tabs>
        {/* Returns sites user has admin permissions for */}
        {(userIsOrgAdmin || userIsSuperAdmin) && (
          <Tabs.Tab label="All Sites">
            <TablePagination>
              <TeachingSiteTable
                page={undefined as never}
                pageSize={undefined as never}
                resetPage={(): void => {
                  throw new Error(`Function not implemented.`);
                }}
                handleTotalResults={(totalResults: number): void => {
                  throw new Error(`Function ${totalResults} not implemented.`);
                }}
              />
            </TablePagination>
          </Tabs.Tab>
        )}

        {/* Returns sites the user has roles in */}
        <Tabs.Tab label="My Sites">
          <TablePagination>
            <MySitesTable
              page={undefined as never}
              pageSize={undefined as never}
              resetPage={(): void => {
                throw new Error(`Function not implemented.`);
              }}
              handleTotalResults={(totalResults: number): void => {
                throw new Error(`Function ${totalResults} not implemented.`);
              }}
            />
          </TablePagination>
        </Tabs.Tab>

        {userIsSuperAdmin && (
          <Tabs.Tab label="Claim a Site">
            <TablePagination>
              <UnclaimedSitesTable
                page={undefined as never}
                pageSize={undefined as never}
                resetPage={(): void => {
                  throw new Error(`Function not implemented.`);
                }}
                handleTotalResults={(totalResults: number): void => {
                  throw new Error(`Function ${totalResults} not implemented.`);
                }}
              />
            </TablePagination>
          </Tabs.Tab>
        )}
        <Tabs.Tab label={userIsSuperAdmin ? "Sandpit Sites" : "My Sandpits"}>
          <TablePagination>
            <SandpitSiteTable
              page={undefined as never}
              pageSize={undefined as never}
              resetPage={(): void => {
                throw new Error(`Function not implemented.`);
              }}
              handleTotalResults={(totalResults: number): void => {
                throw new Error(`Function ${totalResults} not implemented.`);
              }}
            />
          </TablePagination>
        </Tabs.Tab>
      </Tabs>
    </div>
  );
}
